import { render, staticRenderFns } from "./SizeFormDialog.vue?vue&type=template&id=30c56ce2"
import script from "./SizeFormDialog.vue?vue&type=script&lang=js"
export * from "./SizeFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports